const styles = (theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: theme.spacing(1),
      maxWidth: '500px',
      margin: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1),
        maxWidth: 'calc(100% - 16px)',
      },
    },
  },
  dialogTitle: {
    padding: theme.spacing(3, 3, 1, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTypography-h6': {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    '& .MuiIconButton-root': {
      color: theme.palette.text.secondary,
      '&:hover': {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  description: {
    marginBottom: theme.spacing(3),
    fontSize: '0.875rem',
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  uploadButton: {
    borderColor: '#00695c',
    color: '#00695c',
    padding: theme.spacing(1.5),
    fontWeight: 500,
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      fontSize: '8px',
    },
    '&:hover': {
      borderColor: '#004d40',
      backgroundColor: 'rgba(0, 105, 92, 0.04)',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(0.5),
        '& svg': {
          fontSize: '1rem',
        },
      },
    },
  },
  downloadButton: {
    backgroundColor: '#00695c',
    color: '#ffffff',
    padding: theme.spacing(1.5),
    fontWeight: 500,
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      fontSize: '8px',
    },
    '&:hover': {
      backgroundColor: '#004d40',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(0.5),
        '& svg': {
          fontSize: '1rem',
        },
      },
    },
  },
  fileInfo: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  dialogActions: {
    padding: theme.spacing(2, 3, 3, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(0.5),
    },
    '& .MuiButton-outlined': {
      borderColor: theme.palette.grey[300],
      color: theme.palette.text.secondary,
      fontWeight: 500,
      fontSize: '10px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
        padding: theme.spacing(0.75, 2),
      },
      '&:hover': {
        borderColor: theme.palette.grey[400],
        backgroundColor: theme.palette.grey[50],
      },
    },
    '& .MuiButton-contained': {
      backgroundColor: '#00695c',
      fontWeight: 500,
      fontSize: '10px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
        padding: theme.spacing(0.75, 2),
      },
      '&:hover': {
        backgroundColor: '#004d40',
      },
      '&:disabled': {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.text.disabled,
      },
    },
  },
});

export default styles;
